export default function authHeader() {
    let user = localStorage.getItem('jwtToken');
    if(user)
        return `Bearer ${user}`;
    return {};
}